import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout: React.FC = () => {
  return (
    <div className='authentication'>
      <div className='container-fluid p-0'>
        <div className='row g-0'>
          {/* Left side - Illustration */}
          <div className='col-xxl-5 col-xl-5 col-lg-5 d-xl-block d-none px-0'>
            <div className='authentication-cover'>
              <div className='aunthentication-cover-content rounded'>
                <div className='text-center p-5 d-flex align-items-center justify-content-center'>
                  <div>
                    <div className='mb-5'>
                      <img
                        src='/assets/images/authentication/4.png'
                        className='authentication-image'
                        alt='Authentication Cover'
                      />
                    </div>
                    <h6 className='fw-semibold'>Sign In</h6>
                    <p className='fw-normal fs-14 op-7'>
                      Welcome back! Please sign in to continue using our
                      platform.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right side - Form */}
          <div className='col-xxl-7 col-xl-7 col-lg-12'>
            <div className='row justify-content-center align-items-center h-100'>
              <div className='col-xxl-6 col-xl-7 col-lg-7 col-md-7 col-sm-8 col-12'>
                <div className='p-5'>
                  <div className='mb-3'>
                    <a href='/'>
                      <img
                        src='/assets/images/brand-logos/pve-logo.png'
                        alt='Logo'
                        className='authentication-brand desktop-logo'
                      />
                      <img
                        src='/assets/images/brand-logos/pve-logo.png'
                        alt='Logo'
                        className='authentication-brand desktop-dark'
                      />
                    </a>
                  </div>
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
